export default "__VITE_ASSET__Cmm9UMCX__"